import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        toolbar: {
            justifyContent: 'space-between !important',
            background: theme.palette.common.white,
            padding: `${theme.spacing(2)} ${theme.spacing(1)} !important`,
            minHeight: `${theme.spacing(4.5)} !important`,
            margin: `${theme.spacing(1)} !important`,
            borderBottom: '0 !important',
        },
        title: {
            fontSize: '20px !important',
            lineHeight: '24px !important',
            fontWeight: '400 !important',
        },
        toolbarControlEls: {
            display: 'flex',
        },
        toolbarControlEl: {
            alignSelf: 'center',
        },
    }
})
